const capitalizeFirstLetter = (text) => text.substr(0, 1).toUpperCase() + text.substr(1);

const getInitialStateProp = (location) => {
  const state = location.state || {};
  const searchParams = new URLSearchParams(location.search);
  const searchParamsObj = Array.from(searchParams.entries())
    .reduce((acc, [key, value]) => {
      if (['cloth', 'category', 'piece', 'typeOfWork'].includes(key)) return { ...acc, [`selected${capitalizeFirstLetter(key)}`]: value };
      return { ...acc, [key]: value };
    }, {});
  return {
    ...searchParamsObj,
    ...state,
  };
};

export default getInitialStateProp;
